export const SET_AUTH = "SET_AUTH";
export const REMOVE_AUTH = "REMOVE_AUTH";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const GET_ALL_BANKS = "GET_ALL_BANKS";
